import { useEffect, useState } from 'react'
import aa from 'search-insights' 
// import normalizeStats from 'newFunctions/normalizeStats';
import { useAlgoliaHelper } from './useAlgoliaHelper';
import { useUserToken } from './useUserToken';


const productArrayAlgolia = (product) => {
    const idsProduct = product.map( ids => Number(ids?.objectID) )  
    return idsProduct
}


const useAlgoliaData = () => {

    const { token } = useUserToken()
    const { 
        hits, 
        data, 
        startSearch, 
        handleSearchChange, 
        handleChangeIndex,
        handleChangePage,
        handleChangeFilters 
    } = useAlgoliaHelper()
    // } = useAlgoliaHelper({type: 'category'})

    const [ resultsSearch, setResultsSearch ] = useState(null)
    const [ resultsFilters, setResultsFilters ] = useState(null)
    const [ filterSend, setFilterSend ]= useState('')
    const [ categoryName, setCategoryName ] = useState(null)
    const [ search, setSearch ] = useState(null)
    const [ numPage, setNumPage ] = useState(null)
    const [ filtersToAplicate, setFiltersToAplicate ] = useState(null)
    const [ firstRender, setFirstRender ] = useState(null)
    const [ first, setFirst ] = useState(null)
    const [ categFil, setCategFil ] = useState(null)
    const [ typeIn, setTypeIn ] = useState(null)


    const getAlgolia = async (props) =>{
        const {
            searchWord,
            category, 
            pagination, 
            aplicateFilters,
            initial,
            typeInit = 'category',
            orderBy,
            nameComp = ''
        } = props

        // console.log('----------------',props)
        // console.log('getAlgolia ',nameComp,'  -  category: ', category, ' - searchWord: ',searchWord,' pagination: ', pagination,' aplicateFilters: ',aplicateFilters,' initial: ',initial,' orderBy: ',orderBy,' typeInit: ',typeInit)
        
        if(searchWord){
            setSearch( decodeURIComponent(searchWord) )
        }else{
            setSearch( '' )
        }
        if(category){
            setCategoryName( decodeURIComponent(category?.nameCategory) )
            setCategFil( decodeURIComponent(category?.nameCategory) )
        }
        if(pagination){
            setNumPage( pagination - 1 )
        }
        if(aplicateFilters){
            setFiltersToAplicate( aplicateFilters )
        }
        if(initial){
            setFirst( initial )
        }
        if(typeInit){
            setTypeIn(typeInit)
        }
        if(orderBy){
            const newOrder = Number(orderBy)
            if(newOrder === 0){
                handleChangeIndex('sears')
            }
            else if(newOrder === 1){
                handleChangeIndex('sears_price_asc')
            }
            else if(newOrder === 2){
                handleChangeIndex('sears_price_desc')
            }
        }
    }

    useEffect(()=>{
        if(search){
            handleSearchChange(search)
            handleChangePage(0)
        }
    },[search])
    
    useEffect(()=>{
        if(categoryName){
            if(search.length === 0){
                handleSearchChange(categoryName)
            }
            handleChangePage(0)
        }
    },[categoryName])

    useEffect(()=>{
        if(categoryName && numPage){
            handleChangePage(numPage)
        } 
    },[numPage])

    useEffect(()=>{
        if(categoryName && numPage >= 0 ){
            if( filtersToAplicate ){

                let sendFilters = ''
                
                let start = null
                let shipping = null
                let fulfillment = null
                let brands = null
                let discounts = null
                let rangePrice = null
                let categories = null

                // console.log('filtersToAplicate: ',filtersToAplicate)

                if(filtersToAplicate?.reviews){
                    start = {
                        review_rating: 5
                    }
                }
                if(filtersToAplicate?.hasFree){
                    shipping = {
                        has_free_shipping: true
                    }
                }
                if(filtersToAplicate?.fullfilment){
                    fulfillment = {
                        fulfillment: true
                    }
                }
                if(filtersToAplicate?.brands.length >= 1){
                    const listBrands = filtersToAplicate?.brands?.map(brand => {
                        const brandList = {
                            brand: String(brand)
                        } 
                        return brandList
                    })
                    brands = {
                        brand: listBrands
                    }
                }

                if(filtersToAplicate?.discounts?.max){
                    if(filtersToAplicate?.discounts?.max > 10){
                        discounts = {
                            percent_off: {
                                min: Number(filtersToAplicate?.discounts?.min),
                                max: Number(filtersToAplicate?.discounts?.max)
                            }
                        }
                    }else if(filtersToAplicate?.discounts?.min > 1 && filtersToAplicate?.discounts?.max <=10){
                        discounts = {
                            percent_off: {
                                min: 1,
                                max: Number(filtersToAplicate?.discounts?.max)
                            }
                        }
                    }
                }

                if(filtersToAplicate?.rangePrice?.max){
                    rangePrice = {
                        sale_price: {
                            min: Number(filtersToAplicate?.rangePrice?.min),
                            max: Number(filtersToAplicate?.rangePrice?.max)
                        }
                    }
                }

                if(filtersToAplicate?.categories[0]){
                    if(filtersToAplicate?.categories[0]?.lvl2){
                        categories = {
                            hirerarchical_category: `${filtersToAplicate?.categories[0]?.lvl0} > ${filtersToAplicate?.categories[0]?.lvl1} > ${filtersToAplicate?.categories[0]?.lvl2}`
                        }
                    }
                    else if(filtersToAplicate?.categories[0]?.lvl1){
                        categories = {
                            hirerarchical_category: `${filtersToAplicate?.categories[0]?.lvl0} > ${filtersToAplicate?.categories[0]?.lvl1}`
                        }
                    }
                    else if(filtersToAplicate?.categories[0]?.lvl0){
                        categories = {
                            hirerarchical_category: `${filtersToAplicate?.categories[0]?.lvl0}`
                        }  
                    }
                }

                sendFilters = [ start, shipping, fulfillment, brands, categories, discounts, rangePrice ]

                setFilterSend( sendFilters.filter(filter => filter !== null) )
            }
        } 
    },[filtersToAplicate?.reviews, filtersToAplicate?.hasFree, filtersToAplicate?.fullfilment, filtersToAplicate?.categories, filtersToAplicate?.brands, filtersToAplicate?.discounts, filtersToAplicate?.rangePrice])

    useEffect(()=>{
        if(firstRender){
            if(filterSend){
                // console.log('filterSend: ',filterSend)
                handleChangeFilters(filterSend)
            }
        }
    },[filterSend])

    useEffect(() => {
        if(first){
            if(typeIn === 'category'){
                // console.log('1: ',decodeURIComponent(first?.nameCategory), ' ',first?.nameCategory)
                startSearch( first?.nameCategory, 0 )
                setCategFil( decodeURIComponent(first?.nameCategory) )
            }else{
                // console.log('2: ', first)
                startSearch( first, 0 )
                setSearch(first)
            }
            setFirst(null)
            setFirstRender(true)
        }
    }, [first])
    
    useEffect(() => {
        if(token){
            aa('setUserToken', token)
        }
    }, [])


    useEffect(() => {
        if(hits){
            if(hits?.length > 0){
                setResultsSearch({
                    productIDs: productArrayAlgolia(hits),
                    totalResults: data?.results?.nbHits <= 999 ? data?.results?.nbHits : 999,
                    resultsPerPage: data?.results?.hitsPerPage
                })

                // console.log('categoryName in hitss: ',categFil)
                const respCat = data?.results?.hierarchicalFacets.filter( filterName => filterName.name === 'hirerarchical_category' )[0]?.data || null
                const respCategoryFilter = respCat?.filter( nameFilter => nameFilter?.name === categFil?.toLowerCase() )[0] || null
                const orderRespCat = respCat.sort((a, b) => b?.count - a?.count)

  
                // console.log('data: ',data)
                const respReview = data?.results?.disjunctiveFacets.filter(filterName => filterName.name === 'review_rating')[0] || null
                const respFree = data?.results?.disjunctiveFacets.filter(filterName => filterName.name === 'has_free_shipping')[0] || null
                const respFullF = data?.results?.disjunctiveFacets.filter(filterName => filterName.name === 'fulfillment')[0] || null
                const respBrand = data?.results?.disjunctiveFacets.filter(filterName => filterName.name === 'brand')[0] || null
                const respDisc = data?.results?.disjunctiveFacets.filter(filterName => filterName.name === 'percent_off')[0] || null
                const respRange = data?.results?.disjunctiveFacets.filter(filterName => filterName.name === 'sale_price')[0] || null
                // const rStats = normalizeStats(respRange.data)

                const respLastRange = {
                    ...respRange,
                    lastStats : respRange.stats
                }

                const newRespCatgory = {
                    count: null,
                    data: orderRespCat,
                    // data: [respCategoryFilter],
                    escapedValue: null,
                    exhaustive: true,
                    isRefined: true,
                    name: 'hirerarchical_category',
                    path: null
                }

                setResultsFilters({
                    reviews: respReview,
                    hasFree: respFree,
                    fullfilment: respFullF,
                    brands: respBrand,
                    categories: newRespCatgory,
                    discounts: respDisc,
                    rangePrice: respLastRange
                })
            }
        }
    }, [ hits ])


    return {
        getAlgolia,
        resultsSearch,
        filters: resultsFilters
    }
}

export default useAlgoliaData